export const onFormatPurchaseRequestStatus = (status: string) => {
    switch (status) {
        case 'draft':
            return { name: 'Draft', color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
        case 'submitted':
            return { name: 'Submitted', color: 'border-[#f7a21e]', text: 'text-[#f7a21e]' }
        case 'offer_submitted':
            return { name: 'Offer Submitted', color: 'border-[#00b67a]', text: 'text-[#00b67a]' }
        case 'broker_offer_submitted':
            return { name: 'Broker Offer Submitted', color: 'border-[#00b67a]', text: 'text-[#00b67a]' }
        case 'processing':
            return { name: 'Delivered', color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
        case 'completed':
            return { name: 'Completed', color: 'border-[#00b67a]', text: 'text-[#00b67a]' }
        case 'offer_accepted':
            return { name: 'Offer Accepted', color: 'border-[#00b67a]', text: 'text-[#00b67a]' }
        case 'offer_rejected':
            return { name: 'Offer Rejected', color: 'border-[#E50000]', text: 'text-[#E50000]' }
        default:
            return { name: status, color: 'border-[#1389e6]', text: 'text-[#1389e6]' }
    }
}